module.exports = __webpack_public_path__ + "static/media/NoTeamMember.2b024263.png";